// Determine if radio and checkbox-group options should be in a single
// line or on their own lines.
export default function isInline (config) {
  if (typeof config.isInline !== 'undefined') {
    return config.isInline;
  } else {
    return config.options?.length < 5;
  }
}
